/*
 * ========================================
 * Header Hidden
 * ========================================
 */

const customHeader = document.querySelector(
  ".shopify-section-group-header-group"
);

if (customHeader) {
  const updateCustomHeaderState = () => {
    const customHeadings = document.querySelectorAll(
      ".custom-heading"
    );

    const isHeaderHidden = customHeader.classList.contains(
      "shopify-section-header-hidden"
    );

    customHeadings.forEach((customHeading) => {
      customHeading.classList.toggle(
        "is-header-hidden",
        isHeaderHidden
      );
    });
  };

  updateCustomHeaderState();

  const customHeaderObserver = new MutationObserver(() => {
    updateCustomHeaderState();
  });

  customHeaderObserver.observe(customHeader, {
    attributes: true,
    attributeFilter: ["class"]
  });

  document.addEventListener(
    "shopify:section:load",
    updateCustomHeaderState
  );
}

/*
 * ========================================
 * Custom Image Fade In
 * ========================================
 */

(() => {
  const fadeInObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        entry.target.classList.add("is-visible");

        fadeInObserver.unobserve(entry.target);
      });
    },
    {
      threshold: 0.1
    }
  );

  const initCustomImageFadeIn = () => {
    const items = document.querySelectorAll(
      ".collection-random-image-layout__item:not(.fade-init)"
    );

    items.forEach((item) => {
      item.classList.add("fade-init");
      fadeInObserver.observe(item);
    });
  };

  initCustomImageFadeIn();

  document.addEventListener(
    "shopify:section:load",
    initCustomImageFadeIn
  );
})();